import React from 'react';

import { useIntl } from '@edx/frontend-platform/i18n';
import { Alert } from 'ts-paragon';
import { Error } from 'ts-paragon/icons';
import PropTypes from 'prop-types';

import { FORM_SUBMISSION_ERROR, PASSWORD_RESET, PASSWORD_VALIDATION_ERROR } from './data/constants';
import messages from './messages';

function parsePasswordErrorMessage(errorMsg) {
  if (!errorMsg) {
    console.log('[Parser] No error message provided.');
    return { baseMessages: [], parsed: null };
  }

  console.log('[Parser] Raw errorMsg:', errorMsg);

  let baseMessages = [];
  let parsed = null;

  try {
    // Try full JSON parse first
    parsed = JSON.parse(errorMsg);

  } catch (e) {

    // Find possible JSON object using simple substring logic
    const jsonStartIndex = errorMsg.indexOf('{');
    const jsonEndIndex = errorMsg.lastIndexOf('}');

    if (jsonStartIndex !== -1 && jsonEndIndex !== -1 && jsonEndIndex > jsonStartIndex) {
      const jsonString = errorMsg.substring(jsonStartIndex, jsonEndIndex + 1);


      try {
        parsed = JSON.parse(jsonString);

        // Get everything before and after the JSON block
        const beforeJson = errorMsg.substring(0, jsonStartIndex).trim();
        const afterJson = errorMsg.substring(jsonEndIndex + 1).trim();

        // Split into sentences/phrases by punctuation
        const sentenceRegex = /([^\.!\?]+[\.!\?]*\s*)/g;
        const beforeParts = beforeJson.match(sentenceRegex) || [];
        const afterParts = afterJson.match(sentenceRegex) || [];

        // Filter out empty strings
        baseMessages = [
          ...beforeParts.map(s => s.trim()).filter(Boolean),
          ...afterParts.map(s => s.trim()).filter(Boolean)
        ];

      } catch (parseError) {
        // If JSON parsing fails, treat whole string as plain text
        baseMessages = errorMsg.match(/[^\.!\?]+[\.!\?]*\s*/g)?.map(s => s.trim()) || [errorMsg];
      }
    } else {
      // No JSON found; treat the whole string as plain text
      baseMessages = errorMsg.match(/[^\.!\?]+[\.!\?]*\s*/g)?.map(s => s.trim()) || [errorMsg];
    }
  }

  return { baseMessages, parsed };
}
const ResetPasswordFailure = (props) => {
  const { formatMessage } = useIntl();
  const { errorCode, errorMsg } = props;

  let errorMessage = null;
  let heading = formatMessage(messages['reset.password.failure.heading']);
  switch (errorCode) {
    case PASSWORD_RESET.FORBIDDEN_REQUEST:
      heading = formatMessage(messages['reset.server.rate.limit.error']);
      errorMessage = formatMessage(messages['rate.limit.error']);
      break;
    case PASSWORD_RESET.INTERNAL_SERVER_ERROR:
      errorMessage = formatMessage(messages['internal.server.error']);
      break;
    case PASSWORD_VALIDATION_ERROR:
      try {
        const { baseMessages, parsed } = parsePasswordErrorMessage(errorMsg);

        const suggestions = [...baseMessages];
        if (parsed?.suggestions?.length > 0) {
          suggestions.push(...parsed.suggestions);
        }

        errorMessage = (
          <>
            {suggestions?.length > 0 ? (
              <>
                <p className="mb-0">
                  {formatMessage(messages["password.policy.violation.message"])}
                </p>
                {formatMessage(
                  messages["password.policy.violation.tips.heading"]
                )}
                <ul>
                  {suggestions.map((tip, index) => (
                    <li key={index}>{tip}</li>
                  ))}
                </ul>
              </>
            ) : (
              <p className="mb-0">
                {formatMessage(
                  messages["password.policy.violation.lms.message"]
                )}
              </p>
            )}
          </>
        );
      } catch (e) {
        errorMessage = errorMsg;
      }
      break;
    case FORM_SUBMISSION_ERROR:
      errorMessage = formatMessage(messages['reset.password.form.submission.error']);
      break;
    default:
      break;
  }

  if (errorMessage) {
    return (
      <Alert id="validation-errors" className="mb-5" variant="danger" icon={Error}>
        <Alert.Heading>{heading}</Alert.Heading>
        <p>{errorMessage}</p>
      </Alert>
    );
  }

  return null;
};

ResetPasswordFailure.defaultProps = {
  errorCode: null,
  errorMsg: null,
};

ResetPasswordFailure.propTypes = {
  errorCode: PropTypes.string,
  errorMsg: PropTypes.string,
};

export default ResetPasswordFailure;